"use strict";
exports.fcc52d8 = validate10;
const schema11 = {"$schema":"http://json-schema.org/draft-07/schema","type":"object","title":"WizTeamsFederationTitleText","description":"WizTeamsFederationDesc","properties":{"oAuthCredential":{"type":"object","title":"TeamsAdminOAuthCredentialsLabel"},"internalUserSipAddress":{"type":"string","title":"LabelSpecifyInternalSipAddress","pattern":"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"},"externalUserSipAddress":{"type":"string","title":"LabelSpecifyExternalSipAddress","pattern":"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"},"externalUserClient":{"type":"number","title":"LabelExternalClientTypeGroup","default":0,"enum":[0,1,2,3],"enumNames":["LabelTeamsClientRadio","LabelSkypeForBusinessClientRadio","LabelSkypeConsumerClientRadio","LabelTeamsForLifeClientRadio"]},"notice":{"type":"object","title":"PanelTitle_Notice","properties":{"testAccountConsent":{"type":"boolean","title":"TestAccountConsent","description":"NoticeDescription"}},"required":["testAccountConsent"]},"proofOfWork":{"type":"string","title":""}},"required":["oAuthCredential","internalUserSipAddress","externalUserSipAddress","externalUserClient","notice","proofOfWork"],"$id":"fcc52d8"};
const pattern0 = new RegExp("^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$", "u");

function validate10(data, {instancePath="", parentData, parentDataProperty, rootData=data}={}){
/*# sourceURL="fcc52d8" */;
let vErrors = null;
let errors = 0;
if(data && typeof data == "object" && !Array.isArray(data)){
if(data.oAuthCredential === undefined){
const err0 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "oAuthCredential"},message:"must have required property '"+"oAuthCredential"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err0];
}
else {
vErrors.push(err0);
}
errors++;
}
if(data.internalUserSipAddress === undefined){
const err1 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "internalUserSipAddress"},message:"must have required property '"+"internalUserSipAddress"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err1];
}
else {
vErrors.push(err1);
}
errors++;
}
if(data.externalUserSipAddress === undefined){
const err2 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "externalUserSipAddress"},message:"must have required property '"+"externalUserSipAddress"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err2];
}
else {
vErrors.push(err2);
}
errors++;
}
if(data.externalUserClient === undefined){
const err3 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "externalUserClient"},message:"must have required property '"+"externalUserClient"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err3];
}
else {
vErrors.push(err3);
}
errors++;
}
if(data.notice === undefined){
const err4 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "notice"},message:"must have required property '"+"notice"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err4];
}
else {
vErrors.push(err4);
}
errors++;
}
if(data.proofOfWork === undefined){
const err5 = {instancePath,schemaPath:"#/required",keyword:"required",params:{missingProperty: "proofOfWork"},message:"must have required property '"+"proofOfWork"+"'",schema:schema11.required,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err5];
}
else {
vErrors.push(err5);
}
errors++;
}
if(data.oAuthCredential !== undefined){
let data0 = data.oAuthCredential;
if(!(data0 && typeof data0 == "object" && !Array.isArray(data0))){
const err6 = {instancePath:instancePath+"/oAuthCredential",schemaPath:"#/properties/oAuthCredential/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.oAuthCredential.type,parentSchema:schema11.properties.oAuthCredential,data:data0};
if(vErrors === null){
vErrors = [err6];
}
else {
vErrors.push(err6);
}
errors++;
}
}
if(data.internalUserSipAddress !== undefined){
let data1 = data.internalUserSipAddress;
if(typeof data1 === "string"){
if(!pattern0.test(data1)){
const err7 = {instancePath:instancePath+"/internalUserSipAddress",schemaPath:"#/properties/internalUserSipAddress/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"},message:"must match pattern \""+"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"+"\"",schema:"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$",parentSchema:schema11.properties.internalUserSipAddress,data:data1};
if(vErrors === null){
vErrors = [err7];
}
else {
vErrors.push(err7);
}
errors++;
}
}
else {
const err8 = {instancePath:instancePath+"/internalUserSipAddress",schemaPath:"#/properties/internalUserSipAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.internalUserSipAddress.type,parentSchema:schema11.properties.internalUserSipAddress,data:data1};
if(vErrors === null){
vErrors = [err8];
}
else {
vErrors.push(err8);
}
errors++;
}
}
if(data.externalUserSipAddress !== undefined){
let data2 = data.externalUserSipAddress;
if(typeof data2 === "string"){
if(!pattern0.test(data2)){
const err9 = {instancePath:instancePath+"/externalUserSipAddress",schemaPath:"#/properties/externalUserSipAddress/pattern",keyword:"pattern",params:{pattern: "^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"},message:"must match pattern \""+"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$"+"\"",schema:"^([a-zA-Z0-9'!#~_\\-\\.\\^]*[a-zA-Z0-9'!#~_\\-\\^]+)@([a-zA-Z0-9\\-]+\\.)+[a-zA-Z0-9\\-]+$",parentSchema:schema11.properties.externalUserSipAddress,data:data2};
if(vErrors === null){
vErrors = [err9];
}
else {
vErrors.push(err9);
}
errors++;
}
}
else {
const err10 = {instancePath:instancePath+"/externalUserSipAddress",schemaPath:"#/properties/externalUserSipAddress/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.externalUserSipAddress.type,parentSchema:schema11.properties.externalUserSipAddress,data:data2};
if(vErrors === null){
vErrors = [err10];
}
else {
vErrors.push(err10);
}
errors++;
}
}
if(data.externalUserClient !== undefined){
let data3 = data.externalUserClient;
if(!(typeof data3 == "number")){
const err11 = {instancePath:instancePath+"/externalUserClient",schemaPath:"#/properties/externalUserClient/type",keyword:"type",params:{type: "number"},message:"must be number",schema:schema11.properties.externalUserClient.type,parentSchema:schema11.properties.externalUserClient,data:data3};
if(vErrors === null){
vErrors = [err11];
}
else {
vErrors.push(err11);
}
errors++;
}
if(!((((data3 === 0) || (data3 === 1)) || (data3 === 2)) || (data3 === 3))){
const err12 = {instancePath:instancePath+"/externalUserClient",schemaPath:"#/properties/externalUserClient/enum",keyword:"enum",params:{allowedValues: schema11.properties.externalUserClient.enum},message:"must be equal to one of the allowed values",schema:schema11.properties.externalUserClient.enum,parentSchema:schema11.properties.externalUserClient,data:data3};
if(vErrors === null){
vErrors = [err12];
}
else {
vErrors.push(err12);
}
errors++;
}
}
if(data.notice !== undefined){
let data4 = data.notice;
if(data4 && typeof data4 == "object" && !Array.isArray(data4)){
if(data4.testAccountConsent === undefined){
const err13 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/required",keyword:"required",params:{missingProperty: "testAccountConsent"},message:"must have required property '"+"testAccountConsent"+"'",schema:schema11.properties.notice.required,parentSchema:schema11.properties.notice,data:data4};
if(vErrors === null){
vErrors = [err13];
}
else {
vErrors.push(err13);
}
errors++;
}
if(data4.testAccountConsent !== undefined){
let data5 = data4.testAccountConsent;
if(typeof data5 !== "boolean"){
const err14 = {instancePath:instancePath+"/notice/testAccountConsent",schemaPath:"#/properties/notice/properties/testAccountConsent/type",keyword:"type",params:{type: "boolean"},message:"must be boolean",schema:schema11.properties.notice.properties.testAccountConsent.type,parentSchema:schema11.properties.notice.properties.testAccountConsent,data:data5};
if(vErrors === null){
vErrors = [err14];
}
else {
vErrors.push(err14);
}
errors++;
}
}
}
else {
const err15 = {instancePath:instancePath+"/notice",schemaPath:"#/properties/notice/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.properties.notice.type,parentSchema:schema11.properties.notice,data:data4};
if(vErrors === null){
vErrors = [err15];
}
else {
vErrors.push(err15);
}
errors++;
}
}
if(data.proofOfWork !== undefined){
let data6 = data.proofOfWork;
if(typeof data6 !== "string"){
const err16 = {instancePath:instancePath+"/proofOfWork",schemaPath:"#/properties/proofOfWork/type",keyword:"type",params:{type: "string"},message:"must be string",schema:schema11.properties.proofOfWork.type,parentSchema:schema11.properties.proofOfWork,data:data6};
if(vErrors === null){
vErrors = [err16];
}
else {
vErrors.push(err16);
}
errors++;
}
}
}
else {
const err17 = {instancePath,schemaPath:"#/type",keyword:"type",params:{type: "object"},message:"must be object",schema:schema11.type,parentSchema:schema11,data};
if(vErrors === null){
vErrors = [err17];
}
else {
vErrors.push(err17);
}
errors++;
}
validate10.errors = vErrors;
return errors === 0;
}
